import { Pipe, PipeTransform } from '@angular/core';
import { UserName } from '@shared/types/user.type';

@Pipe({
  name: 'captureInitials',
})
export class CaptureInitialsPipe implements PipeTransform {
  transform(user: UserName | null | undefined): string {
    if (!user) {
      return '';
    }

    // Handle both snake_case and camelCase property names
    const firstName = this._stripHonorifics(
      user.first_name ?? user.firstName ?? '',
    );
    const lastName = user.last_name ?? user.lastName ?? '';

    return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  }

  // Removes a leading honorific title (e.g. "Dr.", "Ph.D.") so the initial reflects
  // the person's actual first name rather than their title. Titles are assumed to
  // end with a period; everything after the last period is treated as the name.
  private _stripHonorifics(name: string): string {
    const trimmed = name.trim();
    const dotIndex = trimmed.lastIndexOf('.');

    if (dotIndex === -1) {
      return trimmed;
    }

    const rest = trimmed.slice(dotIndex + 1).trim();

    return rest || trimmed;
  }
}
